import FormConfig from "./FormConfig";
import FormInputRowIsValid from "./FormInputRowIsValid";
import FormRowState from "./FormRowState";

function FormIsValid(rowStates: FormRowState[], config: FormConfig | undefined): boolean {
  if (config === undefined || config === null || config.alwaysInvalid === true || config.formConfig === undefined) {
    return false;
  }
  return config.formConfig.every((row_config, index) => FormInputRowIsValid(rowStates[index], row_config));
}

export default FormIsValid;
